import { client } from '@/common-utils/libraries/axios/axios';
import SIM_CARDS from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateLabel = (onSuccess, onError) => {
    return {
        mutationFn: ({ uuid, label }) => {
            return client.put(replaceParameters(SIM_CARDS.UPDATE.url, { simUuid: uuid }), { uuid, label });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateLabel;